import { animate } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const siteNavigation = document.querySelector('.navigation');

    // Check if the navigation exists
    if (!siteNavigation) {
        return;
    }

    // Select necessary elements using the predefined classes
    const burgerButton = siteNavigation.querySelector(".navigation__menu__burger button");
    const menuInner = siteNavigation.querySelector(".navigation__menu__inner");

    // Ensure both burger button and menu inner are found
    if (burgerButton && menuInner) {
        // Add click event listener to the burger menu button
        burgerButton.addEventListener('click', () => {
            // Toggle the grid and hidden classes
            menuInner.classList.toggle('grid');  // Show menu
            menuInner.classList.toggle('hidden'); // Hide menu

            // Toggle h-full class on the navigation to expand it to full height
            siteNavigation.classList.toggle('h-full');

            // Disable or enable scrolling on the body when the menu is open/closed
            if (menuInner.classList.contains('hidden')) {
                document.body.style.overflow = 'auto';  // Re-enable scrolling
            } else {
                document.body.style.overflow = 'hidden';  // Disable scrolling
            }

            // Change the burger icon to a close icon when the menu is open
            const burgerIcon = burgerButton.querySelector("svg");

            if (menuInner.classList.contains('hidden')) {
                // Switch back to the burger icon
                burgerIcon.innerHTML = `
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                `;
            } else {
                // Switch to the close (X) icon
                burgerIcon.innerHTML = `
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                `;
            }
        });
    }
});